module.exports = {
  data () {
    return {
      loaded: false,
      name: 'Wait for it...'
    }
  },
  methods: {
    loadStuff: async function (done) {
      var self = this
      const response = await self.$http.get('https://api.randomuser.me/', {})
      const stuff = await response.json()

      // extract what we need from the response
      self.name = stuff['results'][0].login.username
      self.loaded = true
      // done()
      return self.loaded
    }
  },
  mounted: function () {
    this.loadStuff()
  }
}



// WEBPACK FOOTER //
// ./src/assets/RandomUser.js